import React from 'react';
import { HeaderLinkProps } from './types';

const HeaderLink: React.FC<HeaderLinkProps> = ({ children, href }) => {
  return (
    <a href={href}>
      <span className="text-[16px] font-bold text-N900 hover:text-text-secondary">{children}</span>
    </a>
  );
};

export { HeaderLink };
